(()=> {
  const contentWrapper = document.querySelector('.popup__content-wrapper');
  if (!contentWrapper) return;

  const url = contentWrapper.dataset.pdfUrl;

  pdfjsLib.GlobalWorkerOptions.workerSrc =
    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

  pdfjsLib.getDocument(url).promise.then(pdf => {
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      pdf.getPage(pageNum).then(page => {
         const viewport = page.getViewport({ scale: window.devicePixelRatio });

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          
          canvas.style.display = "block";
          canvas.style.margin = "0 auto";

          page.render({
            canvasContext: ctx,
            viewport: viewport
          });

        contentWrapper.appendChild(canvas);
      });
    }
  });
})();
